import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from 'angular-l10n';
import { Observable } from 'rxjs';


@Pipe({
  name: 'translateAsync',
  pure: true
})
export class TranslateAsyncPipe implements PipeTransform {
  constructor(protected translation: TranslationService) {}

  public transform(key: string, lang: string, args?: any): Observable<string> {
    return this.translation.translateAsync(key, args, lang);
  }
}
